import { commands } from '~/components/command-menu/commands'
import { CommandMenuView } from '~/components/command-menu/components/CommandMenuView'
import { SelectAccount } from '~/components/command-menu/menus/SelectAccount'
import { SelectAdminWorkspace } from '~/components/command-menu/menus/SelectAdminWorkspace'
import { SelectWorkspace } from '~/components/command-menu/menus/SelectWorkspace'
import { CommandMenuViewType } from '~/components/command-menu/types'

export const ActiveViewMenu = ({
  activeView,
}: {
  activeView: CommandMenuViewType | null
}) => {
  switch (activeView) {
    case null:
      return null
    case 'default':
      return (
        <CommandMenuView
          items={commands}
          placeholder="Search for an action..."
          view={activeView}
        />
      )
    case 'select_account':
      return <SelectAccount view={activeView} />
    case 'select_workspace':
      return <SelectWorkspace view={activeView} />
    case 'select_admin_workspace':
      return <SelectAdminWorkspace view={activeView} />
    default: {
      const _exhaustive: never = activeView
      return _exhaustive
    }
  }
}
